/* Hope Estate — Smart sticky header + cart drawer enhancement */
(function() {
  'use strict';

  // Smart sticky header: hide on scroll down, reveal on scroll up
  var header = document.querySelector('.section-header');
  if (header) {
    var lastScrollY = 0;
    var threshold = 100;
    var ticking = false;

    function updateHeader() {
      var y = window.scrollY;
      if (y < threshold) {
        header.classList.remove('he-header-hidden');
      } else if (y > lastScrollY + 8) {
        header.classList.add('he-header-hidden');
      } else if (y < lastScrollY - 4) {
        header.classList.remove('he-header-hidden');
      }
      lastScrollY = y;
      ticking = false;
    }

    window.addEventListener('scroll', function() {
      if (!ticking) {
        requestAnimationFrame(updateHeader);
        ticking = true;
      }
    }, { passive: true });
  }
})();
